export function fromNullToUndefined<Value>(value: Value | null): Value | undefined {
  return value ?? undefined;
}

export function fromUndefinedToNull<Value>(value: Value | undefined): Value | null {
  return value ?? null;
}

export function deepFromNullToUndefined(object: Record<string | number | symbol, unknown | null>): Record<string | number | symbol, unknown | undefined> {
  return Object.fromEntries(Object.entries(object).map(([key, value]) => ([key, fromNullToUndefined(value)])));
}

type RecursivelyReplaceNullWithUndefined<T> = T extends null
  ? undefined
  : T extends (infer U)[]
    ? RecursivelyReplaceNullWithUndefined<U>[]
    : T extends Record<string, unknown>
      ? { [K in keyof T]: RecursivelyReplaceNullWithUndefined<T[K]> }
      : T;

export function nullsToUndefined<T>(
  obj: T,
): RecursivelyReplaceNullWithUndefined<T> {
  if (obj === null || obj === undefined) {
    return undefined as any;
  }

  if ((obj as any).constructor.name === 'Object' || Array.isArray(obj)) {
    for (const key in obj) {
      obj[key] = nullsToUndefined(obj[key]) as any;
    }
  }

  return obj as any;
}

export function whenDefined<Value, Result>(
  operationOnValue: (value: Value) => Result,
  value: Value | undefined,
) {
  return value === undefined ? undefined : operationOnValue(value);
}